{
  "version": 1,
  "asset_id": "904f8ec3-025d-4244-8c48-610ede6d6a2d",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/904f8ec3-025d-4244-8c48-610ede6d6a2d/form-2848.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/904f8ec3-025d-4244-8c48-610ede6d6a2d/form-2848.jpg",
  "original_filename": "form-2848.jpg",
  "size": 151044,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:39:02Z"
}
